const transformations = [
    'resize',
    'crop',
    'background',
    'format',
    'quality',
    'gravity',
    'dpr',
    'effect',
];
export const isTransformationType = (transformationInput) => {
    return transformations.includes(transformationInput);
};
const format = ['auto', 'webp', 'avif', 'jpeg', 'jpg', 'png', 'gif', 'svg'];
export const isFormatType = (formatInput) => {
    return format.includes(formatInput);
};
const dprValues = ['auto', '1', '2', '3'];
export const isDprType = (value) => {
    return dprValues.includes(value);
};
//# sourceMappingURL=transformations.js.map